import { cookies } from '@/utils/cookies';

import { CATEGORY_PAGE_REFERRER, SIMPLEX_PAGE_REFERRER } from './constants';
import { getAlgoliaInsights } from './storage';
import {
  type GetAlgoliaEventProps,
  type GetAlgoliaInsightsProps,
} from './types';

export const getAlgoliaEventProps = (): GetAlgoliaEventProps => {
  const algoliaInsights = getAlgoliaInsights();

  const userId = cookies.client.get('user_id').value;
  const url = new URL(window.location.href);

  const isFromSearch = document.referrer.includes('search');
  const isFromRecommendedProduct =
    url.searchParams.get('is_recommended_product') === 'true';

  const referrer = url.searchParams.get('referrer');

  const isFromCategoryPage = referrer === CATEGORY_PAGE_REFERRER;
  const isFromSimplexPage = referrer === SIMPLEX_PAGE_REFERRER;

  const isTrackablePage =
    isFromRecommendedProduct ||
    isFromSearch ||
    isFromCategoryPage ||
    isFromSimplexPage;

  const shouldSendEventToAlgolia =
    Boolean(algoliaInsights?.queryID) && isTrackablePage;

  return {
    userId,
    algoliaInsights,
    shouldSendEventToAlgolia,
  };
};

export const mountAlgoliaEvent = (
  algoliaInsights: GetAlgoliaInsightsProps,
  userId?: string
) => {
  return {
    objectIDs: [algoliaInsights.objectID],
    queryID: algoliaInsights.queryID,
    index: algoliaInsights.indexName,
    ...(userId ? { userToken: userId } : { useCookie: true }),
  };
};
